(function () {
  'use strict';

  function init() {
    positionStickies();
    window.addEventListener('resize', positionStickies, { passive: true });

    var filterBtns  = document.querySelectorAll('[data-faq-filter]');
    var questions   = document.querySelectorAll('.sb-faq-item__q');
    var searchInput = document.getElementById('sb-faq-search');
    var noResults   = document.getElementById('sb-faq-no-results');

    // ── Category filtering ──────────────────────
    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = btn.dataset.faqFilter;
        setActiveFilter(filter);
        showSections(filter);
        if (filter !== 'all') {
          var target = document.getElementById('faq-' + filter);
          if (target) {
            var stripHeight = document.querySelector('.sb-faq-strip') ? document.querySelector('.sb-faq-strip').offsetHeight : 0;
            var headerHeight = parseInt(document.documentElement.style.getPropertyValue('--header-height') || 0);
            var offset = target.getBoundingClientRect().top + window.pageYOffset - stripHeight - headerHeight - 16;
            window.scrollTo({ top: offset, behavior: 'smooth' });
          }
        }
        showAllItems();
        if (searchInput) searchInput.value = '';
        if (noResults)   noResults.hidden = true;
      });
    });

    // ── Accordion ───────────────────────────────
    questions.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          closeItem(btn);
        } else {
          openItem(btn);
        }
      });
    });

    // ── Search ──────────────────────────────────
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        var query = searchInput.value.trim().toLowerCase();
        if (query.length > 0) {
          setActiveFilter('all');
          showSections('all');
        }
        runSearch(query, noResults);
      });
    }
  }

  // Measure the actual rendered header height and apply it to sticky elements
  function positionStickies() {
    window.requestAnimationFrame(function () {
      var headerGroup = document.getElementById('header-group');
      var strip   = document.querySelector('.sb-faq-strip');
      var sidebar = document.querySelector('.sb-faq-sidebar');

      if (!headerGroup || !strip) return;

      var headerH = headerGroup.offsetHeight;
      var stripH  = strip.offsetHeight;

      strip.style.top = headerH + 'px';

      if (sidebar) {
        sidebar.style.top = (headerH + stripH + 24) + 'px';
      }
    });
  }

  function setActiveFilter(filter) {
    document.querySelectorAll('.sb-faq-strip__btn').forEach(function (btn) {
      btn.classList.toggle('sb-faq-strip__btn--active', btn.dataset.faqFilter === filter);
    });
    document.querySelectorAll('.sb-faq-sidebar__btn').forEach(function (btn) {
      btn.classList.toggle('sb-faq-sidebar__btn--active', btn.dataset.faqFilter === filter);
    });
  }

  function showSections(filter) {
    document.querySelectorAll('.sb-faq-section').forEach(function (section) {
      section.hidden = filter !== 'all' && section.dataset.faqCategory !== filter;
    });
  }

  function showAllItems() {
    document.querySelectorAll('.sb-faq-item').forEach(function (item) {
      item.hidden = false;
    });
  }

  function runSearch(query, noResults) {
    var items = document.querySelectorAll('.sb-faq-item');
    var anyVisible = false;

    items.forEach(function (item) {
      var match = query === '' || item.textContent.toLowerCase().indexOf(query) !== -1;
      item.hidden = !match;
      if (match) anyVisible = true;
    });

    document.querySelectorAll('.sb-faq-section').forEach(function (section) {
      var hasVisible = false;
      section.querySelectorAll('.sb-faq-item').forEach(function (item) {
        if (!item.hidden) hasVisible = true;
      });
      section.hidden = !hasVisible;
    });

    if (noResults) {
      noResults.hidden = query === '' || anyVisible;
    }
  }

  function openItem(btn) {
    btn.setAttribute('aria-expanded', 'true');
    var icon = btn.querySelector('.sb-faq-item__icon');
    if (icon) icon.textContent = '−';
    var answer = document.getElementById(btn.getAttribute('aria-controls'));
    if (answer) answer.hidden = false;
  }

  function closeItem(btn) {
    btn.setAttribute('aria-expanded', 'false');
    var icon = btn.querySelector('.sb-faq-item__icon');
    if (icon) icon.textContent = '+';
    var answer = document.getElementById(btn.getAttribute('aria-controls'));
    if (answer) answer.hidden = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
